import React, { useEffect, useState } from "react";
import "./ProcurementTable.css";
import { getProcurementRecord } from "../../../Rest_api/RestApi";

const optionst = ["BUY", "SELL", "BANKING"];

const options = [
  "TAM - DAC",
  "TAM - INTRADAY",
  "TAM - WEEKLY",
  "TAM - ANY DAY",
  "TAM - MONTHLY",
  "BILATERAL/DIRECT",
  "REVERSE AUCTION",
  "ANY DAY (REVERSE AUCTION)",
  "BANKING",
];

const options1 = [
  "DEEP",
  "GNA Energy",
  "HPX", 
  "IEX", 
  "PXIL", 
  "NA",
];

const options2 = [
  "NA",
  "PTC INDIA LTD.",
  "NTPC VIDYUT VYAPAR NIGAM LTD.",
  "ADANI ENTERPRISES LTD.",
  "TATA POWER TRADING COMPANY (P) LTD.",
  "MANIKARAN POWER LTD.",
  "ARUNACHAL PRADESH POWER CORPORATION (P) LTD.",
  "JSW POWER TRADING COMPANY LTD",
  "GMR ENERGY TRADING LTD.",
  "INSTINCT INFRA & POWER LTD.",
  "GREENKO ENERGIES PVT LTD",
  "STATKRAFT MARKETS PVT. LTD.",
  "KREATE ENERGY (I) PVT. LTD.",
  "SHREE CEMENT LTD.",
  "ADARSH STAINLESS PVT. LTD.",
  "RPG POWER TRADING COMPANY LTD.",
  "ALTILIUM ENERGIE PRIVATE LIMITED",
  "KUNDAN INTERNATIONAL PVT. LTD.",
  "AMBITIOUS POWER TRADING COMPANY LTD.",
  "ENERGYEDGE POWER TRADING PVT. LTD.",
  "SARANYU POWER TRADING PRIVATE LIMITED",
  "IDEAL ENERGY SOLUTION PVT. LTD.",
  "ABJA POWER PRIVATE LIMITED",
  "REFEX INDUSTRIES LTD.",
  "REFEX ENERGY LIMITED",
  "NLC INDIA LTD.",
  "SJVN LTD.",
  "POWERFULL ENERGY TRADING PVT. LTD.",
  "INSTANT VENTURES PVT. LTD.",
  "ELSA CONSULTANCY",
  "CUSTOMIZED ENERGY SOLUTIONS INDIA (P) LTD.",
  "SHUBHEKSHA ADVISORS PVT. LTD.",
  "GITA POWER & INFRASTRUCTURE PRIVATE LIMITED",
  "SAINI POWER TRANSACTOR",
  "NEFA POWER TRADING PVT. LTD.",
  "PHILLIP COMMODITIES INDIA (P) LTD.",
  "REL POWER TRADING LLP",
  "SHELL ENERGY MARKETING AND TRADING INDIA PVT. LTD.",
  "RENESYS SOLAR PVT. LTD.",
  "RENEURJA POWER LLP",
  "OTHER",
];

const bilateraloptions = [
  "NA",
  "PTC INDIA LTD.",
  "NTPC VIDYUT VYAPAR NIGAM LTD.",
  "ADANI ENTERPRISES LTD.",
  "TATA POWER TRADING COMPANY (P) LTD.",
  "MANIKARAN POWER LTD.",
  "ARUNACHAL PRADESH POWER CORPORATION (P) LTD.",
  "JSW POWER TRADING COMPANY LTD",
  "GMR ENERGY TRADING LTD.",
  "INSTINCT INFRA & POWER LTD.",
  "GREENKO ENERGIES PVT LTD",
  "STATKRAFT MARKETS PVT. LTD.",
  "KREATE ENERGY (I) PVT. LTD.",
  "SHREE CEMENT LTD.",
  "ADARSH STAINLESS PVT. LTD.",
  "RPG POWER TRADING COMPANY LTD.",
  "ALTILIUM ENERGIE PRIVATE LIMITED",
  "KUNDAN INTERNATIONAL PVT. LTD.",
  "AMBITIOUS POWER TRADING COMPANY LTD.",
  "ENERGYEDGE POWER TRADING PVT. LTD.",
  "SARANYU POWER TRADING PRIVATE LIMITED",
  "IDEAL ENERGY SOLUTION PVT. LTD.",
  "ABJA POWER PRIVATE LIMITED",
  "REFEX INDUSTRIES LTD.",
  "REFEX ENERGY LIMITED",
  "NLC INDIA LTD.",
  "SJVN LTD.",
  "POWERFULL ENERGY TRADING PVT. LTD.",
  "INSTANT VENTURES PVT. LTD.",
  "ELSA CONSULTANCY",
  "CUSTOMIZED ENERGY SOLUTIONS INDIA (P) LTD.",
  "SHUBHEKSHA ADVISORS PVT. LTD.",
  "GITA POWER & INFRASTRUCTURE PRIVATE LIMITED",
  "SAINI POWER TRANSACTOR",
  "NEFA POWER TRADING PVT. LTD.",
  "PHILLIP COMMODITIES INDIA (P) LTD.",
  "REL POWER TRADING LLP",
  "SHELL ENERGY MARKETING AND TRADING INDIA PVT. LTD.",
  "RENESYS SOLAR PVT. LTD.",
  "RENEURJA POWER LLP",
  "OTHER",
];

const ProcurementForm = () => {
  const editId = localStorage.getItem("procurement_edit_id");

  const initialState = {
    type_of_transaction: null,
    purchase_through_product: null,
    platform: null,
    tender_no: null,
    trader_bidder: null,
    application_no: null,
    name_of_counterparty_generator: null,
    drawal_purchase_import_date_from: null,
    drawal_purchase_import_date_to: null,
    drawal_purchase_import_time_from: null,
    drawal_purchase_import_time_to: null,
    drawal_purchase_import_mw: null,
    drawal_purchase_import_lu: null,
    rate: null,
    banking_factor:null,
    amount_cr_per_day: null,
    inject_sell_export_date_from: null,
    inject_sell_export_date_to: null,
    inject_sell_export_time_from: null,
    inject_sell_export_time_to: null,
    inject_sell_export_mw: null,
    inject_sell_export_lu: null,
    ppa_date_agreement_date: null,
    approval_id_agreement_id: null,
    loi_number: null,
    loi_date:null,
  };
  const [formData, setFormData] = useState(initialState);

  useEffect(() => {
    if (editId) {
      handleFetchData();
    }
  }, []);

  async function handleFetchData() {
    try {
      const response = await fetch(
        `https://datahub.gna.energy/rajasthan_procurement/get?id=${editId}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.debug(data);
      setFormData(data?.data?.[0]);
    } catch (error) {
      console.error("Error fetching Procurement Record :", error);
      return [];
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (
      (formData?.type_of_transaction === "BUY" ||
        formData?.type_of_transaction === "BANKING") &&
      formData?.drawal_purchase_import_date_from ===
        formData?.drawal_purchase_import_date_to &&
      formData?.drawal_purchase_import_time_from >=
        formData?.drawal_purchase_import_time_to
    ) {
      alert("For Drawal, From Time cannot be later than or equal to To Time.");
      return;
    }

    if (
      (formData?.type_of_transaction === "SELL" ||
        formData?.type_of_transaction === "BANKING") &&
      formData?.inject_sell_export_date_from ===
        formData?.inject_sell_export_date_to &&
      formData?.inject_sell_export_time_from >=
        formData?.inject_sell_export_time_to
    ) {
      alert("For Inject, From Time cannot be later than or equal to To Time.");
      return;
    }

    if (editId) {
      fetch("https://datahub.gna.energy/rajasthan_procurement/update", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          localStorage.removeItem("procurement_edit_id");
          alert(res);
          const form = document.getElementById("procurement-form");
          if (form) form.reset();
        })
        .catch((error) => console.error(error));
    } else {
      fetch("https://datahub.gna.energy/rajasthan_procurement/insert", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          alert(res);
          const form = document.getElementById("procurement-form");
          if (form) form.reset();
        })
        .catch((error) => console.error(error));
    }
  };

  return (
    <div className="page-container">
      <form className="form" id="procurement-form" onSubmit={handleSubmit}>
        <div className="form-section">
          <div className="form-section-sub">
            <div className="form-dropdown">
              <label className="block-head" title = "Types of Transaction">Types of Transaction</label>
              <select
                name="type_of_transaction"
                value={
                  formData?.type_of_transaction === "PURCHASE"
                    ? "BUY"
                    : formData?.type_of_transaction
                }
                onChange={handleChange}
                className="select-option"
                required
              >
                <option value="">-- Select an Option --</option>
                {optionst.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-dropdown">
              <label className="block-head" title = "Purchase through / Product">Purchase through / Product</label>
              <select
                name="purchase_through_product"
                value={formData?.purchase_through_product}
                onChange={handleChange}
                className="select-option"
                required
              >
                <option value="">-- Select an Option --</option>
                {options.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-dropdown">
              <label className="block-head" title = "Platform">Platform</label>
              <select
                name="platform"
                value={formData?.platform}
                onChange={handleChange}
                className="select-option"
                required
              >
                <option value="">-- Select an Option --</option>
                {options1.map((option, index) => (
                  <option key={index} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-section-sub">
              <div className="datetime">
                <label className="blockhead" title = "Tender No /Transaction No">Tender No /Transaction No</label>
                <input
                  type="text"
                  className="field1"
                  name="tender_no"
                  onChange={handleChange}
                  value={formData?.tender_no}
                />
              </div>
              <div className="form-dropdown">
                <label className="block-head" title = "Trader/ Bidder">Trader/ Bidder</label>
                <select
                  name="trader_bidder"
                  value={formData?.trader_bidder}
                  onChange={handleChange}
                  className="select-option"
                  required
                >
                  <option value="">-- Select an Option --</option>
                  {(formData?.purchase_through_product === "BILATERAL/DIRECT"
                    ? bilateraloptions
                    : options2
                  )?.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="datetime">
              <label className="blockhead" title = "Name of Counterparty / Generator">
                Name of Counterparty / Generator
              </label>
              <input
                type="text"
                className="field1"
                name="name_of_counterparty_generator"
                onChange={handleChange}
                value={formData?.name_of_counterparty_generator}
              />
            </div>
          </div>
        </div>

        {/* drawl section */}
        {(formData?.type_of_transaction === "PURCHASE" ||
          formData?.type_of_transaction === "BUY" ||
          formData?.type_of_transaction === "BANKING") && (
          <div className="drawal-section">
            <h2 className="drawal-heading">Drawl / Purchase / Buy / Import</h2>
            <div className="drawal-fields">
              <div className="field-group">
                <label className="drawalblockhead" title = "From Date">From Date:</label>
                <input
                  type="date"
                  name="drawal_purchase_import_date_from"
                  value={formData?.drawal_purchase_import_date_from}
                  onChange={handleChange}
                  className="drawalfield1"
                  required
                />
              </div>
              <div className="field-group">
                <label className="drawalblockhead" title = "To Date">To Date:</label>
                <input
                  type="date"
                  name="drawal_purchase_import_date_to"
                  value={formData?.drawal_purchase_import_date_to}
                  onChange={handleChange}
                  className="drawalfield1"
                  required
                />
              </div>
              <div className="field-group">
                <label className="drawalblockhead" title = "From Time">From Time:</label>
                <input
                  type="time"
                  name="drawal_purchase_import_time_from"
                  value={formData?.drawal_purchase_import_time_from}
                  onChange={handleChange}
                  className="drawalfield1"
                  required
                />
              </div>
              <div className="field-group">
                <label className="drawalblockhead" title = "To Time">To Time:</label>
                <input
                  type="time"
                  name="drawal_purchase_import_time_to"
                  value={formData?.drawal_purchase_import_time_to}
                  onChange={handleChange}
                  className="drawalfield1"
                  required
                />
              </div>
              <div className="field-group">
                <label className="drawalblockhead" title = "Mega Watt">MW</label>
                <input
                  type="text"
                  className="drawalfield1"
                  name="drawal_purchase_import_mw"
                  onChange={handleChange}
                  value={formData?.drawal_purchase_import_mw}
                />
              </div>
              <div className="field-group">
                <label className="drawalblockhead" title = "Total Lakhs per Unit">Total LU</label>
                <input
                  type="text"
                  onChange={handleChange}
                  className="drawalfield1"
                  name="drawal_purchase_import_lu"
                  value={formData?.drawal_purchase_import_lu}
                />
              </div>
            </div>
          </div>
        )}

        <div className="form-section">
          <div className="form-section-sub">
            <div className="datetime">
              <label className="blockhead" title = "Rate (₹) / Kilo Watt per Hour">Rate (₹) / kWh</label>
              <input
                type="text"
                className="field1"
                name="rate"
                onChange={handleChange}
                value={formData?.rate}
              />
            </div>
            <div className="datetime">
              <label className="blockhead"  title = "Banking factor (%)">Banking factor (%)</label>
              <input
                type="text"
                className="field1"
                name="banking_factor"
                onChange={handleChange}
                value={formData?.banking_factor}
              />
            </div>
            <div className="datetime">
              <label className="blockhead" title = "Amount(Cr) per day">Amount(Cr) per day</label>
              <input
                type="text"
                className="field1"
                name="amount_cr_per_day"
                onChange={handleChange}
                value={formData?.amount_cr_per_day}
              />
            </div>
            {/* <div className="datetime">
              <label className="blockhead">Application No.</label>
              <input type="text" className="field1" name="application_no" />
            </div> */}
          </div>
        </div>

        {(formData?.type_of_transaction === "SELL" ||
          formData?.type_of_transaction === "BANKING") && (
          <div className="drawal-section">
            <h2 className="drawal-heading"> Inject / Sell / Export </h2>
            <div className="drawal-fields">
              <div className="field-group">
                <label className="drawalblockhead" title = "From Date">From Date:</label>
                <input
                  type="date"
                  name="inject_sell_export_date_from"
                  value={formData?.inject_sell_export_date_from}
                  onChange={handleChange}
                  className="drawalfield1"
                  required
                />
              </div>
              <div className="field-group">
                <label className="drawalblockhead" title = "To Date">To Date:</label>
                <input
                  type="date"
                  name="inject_sell_export_date_to"
                  value={formData?.inject_sell_export_date_to}
                  onChange={handleChange}
                  className="drawalfield1"
                  required
                />
              </div>
              <div className="field-group">
                <label className="drawalblockhead" title = "From Time">From Time:</label>
                <input
                  type="time"
                  name="inject_sell_export_time_from"
                  value={formData?.inject_sell_export_time_from}
                  onChange={handleChange}
                  className="drawalfield1"
                  required
                />
              </div>
              <div className="field-group">
                <label className="drawalblockhead" title = "To Time">To Time:</label>
                <input
                  type="time"
                  name="inject_sell_export_time_to"
                  value={formData?.inject_sell_export_time_to}
                  onChange={handleChange}
                  className="drawalfield1"
                  required
                />
              </div>
              <div className="field-group">
                <label className="drawalblockhead" title = "Mega Watt">MW</label>
                <input
                  type="text"
                  className="drawalfield1"
                  name="inject_sell_export_mw"
                  value={formData?.inject_sell_export_mw}
                  onChange={handleChange}
                />
              </div>
              <div className="field-group">
                <label className="drawalblockhead" title = "Total Lakhs per Unit">Total LU</label>
                <input
                  type="text"
                  className="drawalfield1"
                  name="inject_sell_export_lu"
                  value={formData?.inject_sell_export_lu}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        )}

        <div className="form-section">
          <div className="form-section-sub">
            <div className="datetime">
              <label className="blockhead"  title = "Power Purchase Agreement Date/ Agreement Date">
                PPA Date/ Agreement Date
              </label>
              <input
                type="date"
                className="field1"
                name="ppa_date_agreement_date_loi_date"
                value={formData?.ppa_date_agreement_date}
                onChange={handleChange}
              />
            </div>

            <div className="datetime">
              <label className="blockhead" title = "Approval ID/ Agreement ID">
                Approval ID/ Agreement ID
              </label>
              <input
                type="text"
                className="field1"
                name="approval_id_agreement_id"
                value={formData?.approval_id_agreement_id}
                onChange={handleChange}
              />
            </div>

            <div className="datetime">
              <label className="blockhead" title = "Letter Of Intent Date">
                LOI Date
              </label>
              <input
                type="date"
                className="field1"
                name="loi_date"
                value={formData?.loi_date}
                onChange={handleChange}
              />
            </div>


            <div className="datetime">
              <label className="blockhead" title = "Letter Of Intent No.">
                LOI No.
              </label>
              <input
                type="text"
                className="field1"
                name="loi_number"
                value={formData?.loi_number}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="button">
          <button type="submit" className="btn-sub">
            {editId ? "Update" : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProcurementForm;
